// 以「epoch day」（自 1970-01-01 起的天數，UTC 日曆）表示日期：整數、可比較、JSON 精簡。

const MS_PER_DAY = 86_400_000;

/** 台灣固定 UTC+8、沒有日光節約時間，所以可以直接位移，不需要時區資料庫。 */
const TAIPEI_OFFSET_MS = 8 * 60 * 60 * 1000;

export function epochDay(y: number, m: number, d: number): number {
  return Math.floor(Date.UTC(y, m - 1, d) / MS_PER_DAY);
}

export function fromEpochDay(day: number): { y: number; m: number; d: number } {
  const date = new Date(day * MS_PER_DAY);
  return { y: date.getUTCFullYear(), m: date.getUTCMonth() + 1, d: date.getUTCDate() };
}

/** 某個時間點在台灣是哪一天。 */
export function taipeiEpochDay(now: Date | number): number {
  const ms = typeof now === 'number' ? now : now.getTime();
  return Math.floor((ms + TAIPEI_OFFSET_MS) / MS_PER_DAY);
}

export function isLeapYear(y: number): boolean {
  return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
}

export function daysInMonth(y: number, m: number): number {
  return [31, isLeapYear(y) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1] ?? 0;
}

/** 0 = 星期日 … 6 = 星期六 */
export function weekday(day: number): number {
  // 1970-01-01 是星期四
  return (((day + 4) % 7) + 7) % 7;
}
